import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { RATIO_TONES, share } from './objectiveFormat';

/**
 * The KPI tile used across all three objective tabs. `bar` (0-1) draws a thin
 * progress rule under the number — enough to read the magnitude without
 * colour-coding a metric that has no agreed target.
 */
const StatTile = ({ label, value, hint, tone = RATIO_TONES.neutral, accent = '#cbd5e1', bar = null }) => (
  <div
    className="tw-flex-1 tw-min-w-[210px] tw-rounded-lg tw-border tw-border-slate-200 tw-border-l-4 tw-bg-white tw-px-4 tw-py-3 tw-shadow-sm"
    style={{ borderLeftColor: accent }}
  >
    <p className="tw-mb-1 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-400">{label}</p>
    <p className="tw-mb-0 tw-text-3xl tw-font-bold tw-tabular-nums tw-leading-none" style={{ color: tone }}>{value}</p>
    {bar !== null && (
      <div className="tw-mt-2 tw-h-1.5 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-slate-100">
        <div className="tw-h-full tw-rounded-full" style={{ width: `${share(bar, 1) * 100}%`, backgroundColor: tone }} />
      </div>
    )}
    {hint && <p className="tw-mb-0 tw-mt-1.5 tw-text-[11px] tw-text-slate-400">{hint}</p>}
  </div>
);

StatTile.propTypes = {
  label:  PropTypes.string.isRequired,
  value:  PropTypes.node.isRequired,
  hint:   PropTypes.node,
  tone:   PropTypes.string,
  accent: PropTypes.string,
  bar:    PropTypes.number,
};

export default memo(StatTile);
